export type ReplenishmentStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'CANCELED'

export type ReplenishmentPriority = 20 | 40 | 70

export type ReplenishmentViewerType = 'PICKING_LIST'

export const replenishmentsExcelKeys = [
  'number',
  'sku',
  'source',
  'target',
  'quantity',
  'priority',
  'action',
]

export type ReplenishmentField =
  | 'replenishmentNumber'
  | 'createdAt'
  | 'product._id'
  | 'product.SKU'
  | 'warehouseId'
  | 'source._id'
  | 'target._id'
  | 'status'
  | 'requiredQty'
  | 'movedQty'
  | 'userId'
  | 'priority'
